(function() {
  jQuery('.countdown-timerv2').each(function() {
    const $banner = jQuery(this);
    const startTimeRaw = $banner.data('start'); // "YYYY-MM-DDTHH:MM:SSZ"
    const endTimeRaw = $banner.data('end');     // "YYYY-MM-DDTHH:MM:SSZ"

    const startTime = startTimeRaw ? new Date(startTimeRaw).getTime() : null;
    const endTime = new Date(endTimeRaw).getTime();

    const $timerEl = $banner.find('.flip-timer');
    if (isNaN(endTime)) {
      console.error("Invalid countdown date:", endTimeRaw);
      $timerEl.text("Invalid date");
      return;
    }

    const groups = ['d','h','m','s'];
    const labels = { d: 'Days', h: 'Hours', m: 'Minutes', s: 'Seconds' };
    const digits = {};

    function initializeTimer() {
      if ($timerEl.children().length === 0) {
        groups.forEach(key => {
          const $group = jQuery('<div>').addClass('flip-group');
          $group.append(jQuery('<div>').addClass('flip-label').text(labels[key]));
          const $digitsWrapper = jQuery('<div>').addClass('digits-wrapper');
          const $digit = jQuery('<div>').addClass('flip-digit').text('00');
          $digitsWrapper.append($digit);
          $group.append($digitsWrapper);
          digits[key] = [$digit];
          $timerEl.append($group);
        });
      }
    }

    function updateTimer() {
      const now = new Date().getTime();

      if (startTime && now < startTime) {
        $banner.hide();
        return;
      }

      const distance = endTime - now;
      if (distance < 0) {
        $banner.hide();
        clearInterval(interval);
        return;
      }

      $banner.show();

      const timeValues = {
        d: Math.floor(distance / (1000 * 60 * 60 * 24)),
        h: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        m: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        s: Math.floor((distance % (1000 * 60)) / 1000)
      };

      groups.forEach(key => {
        digits[key][0].text(timeValues[key].toString().padStart(2,'0'));
      });
    }

    initializeTimer();
    const interval = setInterval(updateTimer, 1000);
    updateTimer();
  });
})();

(function () {
  function handleBannerClick(e) {
    const banner = e.target.closest('.countdown-timerv2[data-bar-url]');
    if (!banner) return;

    // Allow inner anchor links to behave normally
    if (e.target.closest('a')) return;

    window.location.href = banner.dataset.barUrl;
  }

  function handleBannerKeydown(e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;

    const banner = document.activeElement;
    if (!banner?.classList.contains('countdown-timerv2')) return;
    if (!banner.dataset.barUrl) return;

    e.preventDefault();
    window.location.href = banner.dataset.barUrl;
  }

  document.addEventListener('click', handleBannerClick);
  document.addEventListener('keydown', handleBannerKeydown);
})();
